import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Fade from '@mui/material/Fade';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import { makeStyles } from 'tss-react/mui';
import DiscoverIcon from '@mui/icons-material/Explore';
import React, { useEffect, useState } from 'react';
import Link from '@mui/material/Link';

const useStyles = makeStyles()(theme => ({
  paper: {
    padding: theme.spacing(1),
  },
}));

const PopularDestinationsPopup = props => {
  const { classes } = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const [innerWidth, setInnerWidth] = useState(undefined);

  useEffect(() => {
    setInnerWidth(window.innerWidth);
  }, []);

  const { countrySlug, destinations, subdivision } = props;

  const handleClick = event => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = event => {
    if (anchorEl && anchorEl.contains(event.target)) {
      return;
    }

    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'transitions-popper' : undefined;

  return (
    <>
      <Button variant="contained" color="primary" onClick={handleClick}>
        <span className="pr-1">Popular in {props.title}</span>
        <DiscoverIcon />
      </Button>
      <Popper id={id} open={open} anchorEl={anchorEl} transition>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <div>
              <ClickAwayListener onClickAway={handleClose}>
                <Paper
                  className={classes.paper}
                  style={{
                    minWidth: innerWidth ? `${innerWidth * 0.7}px` : '250px',
                  }}
                >
                  <div className="container">
                    <div className="row">
                      {destinations.map((location, index) => {
                        //   limit results
                        if (!location || !location.subdivision || index > 11) {
                          return <></>;
                        }
                        return (
                          <div
                            className="col"
                            key={`${countrySlug}_${
                              location.subdivision
                                ? location.subdivision
                                : `${subdivision}_${location.city}`
                            }`}
                          >
                            <Link
                              onClick={() => setAnchorEl(null)}
                              color="textPrimary"
                              href={`/destinations/${countrySlug}/${
                                location.subdivision
                                  ? location.subdivision
                                  : `${subdivision}/${location.city}`
                              }`}
                            >
                              <MenuItem>
                                <ListItemText
                                  primary={
                                    location.city
                                      ? location.city
                                      : location.subdivision
                                  }
                                />
                              </MenuItem>
                            </Link>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </Paper>
              </ClickAwayListener>
            </div>
          </Fade>
        )}
      </Popper>
    </>
  );
};

export default PopularDestinationsPopup;
